import { render, staticRenderFns } from "./OnboardingHeader.vue?vue&type=template&id=6b527060&scoped=true"
import script from "./OnboardingHeader.vue?vue&type=script&lang=ts"
export * from "./OnboardingHeader.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingHeader.vue?vue&type=style&index=0&id=6b527060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b527060",
  null
  
)

export default component.exports